import React from "react";
import "./Home.css";
import {
  FaStar,
  FaQuoteRight,
  FaUserCircle
} from "react-icons/fa";
import wm from "../images/washing repair.webp"

function Home() {
  return (


    <>
    <div className="home-container">

      {/* Hero Section */}

      <section className="hero-section">

        {/* Left Side */}

        <div className="hero-content">

          <span className="top-badge">
            Chennai’s Trusted Multi Brand Service Center
          </span>

          <h1>
            One Solution <br />
            For All Washing <br />
            Machine Brands
          </h1>

          <p>
            Professional doorstep repair and maintenance service for
            fully automatic, semi automatic and front load washing
            machines. Expert support for all major brands with genuine
            spare parts and experienced technicians.
          </p>

          {/* Buttons */}

          <div className="hero-buttons">

            <button className="primary-btn">
              Book Service
            </button>

           <button className="secondary-btn">
  <a href="tel:+919790066906">Call Now</a>
</button>

          </div>

          {/* Brand Logos */}

          <div className="brand-wrapper">

            <h3>We Service All Leading Brands</h3>

            <div className="brand-grid">

              <div className="brand-card">LG</div>

              <div className="brand-card">Samsung</div>

              <div className="brand-card">IFB</div>

              <div className="brand-card">Bosch</div>

              <div className="brand-card">Whirlpool</div>

              <div className="brand-card">Haier</div>

              <div className="brand-card">Panasonic</div>

              <div className="brand-card">Godrej</div>

            </div>

          </div>

        </div>

        {/* Right Side */}

        <div className="hero-image-section">

          <div className="main-image-card">

            <img
              src={wm}
              alt="washing-machine-service"
            />

          </div>

          {/* Experience Card */}

          <div className="experience-card">

            <h2>15+</h2>

            <p>Years Experience</p>

          </div>

          {/* Customer Card */}

          <div className="customer-card">

            <h2>12K+</h2>

            <p>Happy Customers</p>

          </div>

        </div>

      </section>


      

      {/* Bottom Service Cards */}

      <section className="service-highlights">

        <div className="highlight-card">

          <h2>Same Day Service</h2>

          <p>
            Quick technician support across all Chennai areas.
          </p>

        </div>

        <div className="highlight-card">

          <h2>Multi Brand Experts</h2>

          <p>
            Skilled technicians for all washing machine brands.
          </p>

        </div>

        <div className="highlight-card">

          <h2>Affordable Pricing</h2>

          <p>
            Transparent service charges without hidden fees.
          </p>

        </div>

      </section>

    </div>


    <section className="service-area-section">

  {/* Left Side */}

  <div className="service-area-content">

    <span>Service Areas</span>

    <h1>
      Washing Machine <br />
      Service Available <br />
      Across Chennai
    </h1>

    <p>
      Our expert multi brand washing machine technicians are available
      in all major locations across Chennai for fast doorstep repair
      and maintenance service.
    </p>

    {/* Area List */}

    <div className="area-list">

      <div className="area-card">Anna Nagar</div>

      <div className="area-card">Velachery</div>

      <div className="area-card">Tambaram</div>

      <div className="area-card">Porur</div>

      <div className="area-card">OMR</div>

      <div className="area-card">T Nagar</div>

      <div className="area-card">Medavakkam</div>

      <div className="area-card">Adyar</div>

    </div>

  </div>

  {/* Right Side */}

  <div className="service-map">

    {/* Circle */}

    <div className="map-circle">

      <div className="pulse pulse1"></div>

      <div className="pulse pulse2"></div>

      <div className="pulse pulse3"></div>

      <div className="center-dot"></div>

      <h2>Chennai</h2>

    </div>

  </div>

</section>

     <section className="whychoose-section">

      {/* Heading */}

      <div className="whychoose-heading">

        <span>Why Choose Us</span>

        <h1>
          Trusted Multi Brand <br />
          Washing Machine Service Center
        </h1>

        <p>
          We provide professional doorstep repair services with experienced
          technicians, genuine spare parts and affordable pricing across Chennai.
        </p>

      </div>

      {/* Cards */}

      <div className="whychoose-grid">

        <div className="why-card">

          <div className="icon-box">
            🔧
          </div>

          <h2>Expert Technicians</h2>

          <p>
            Skilled and experienced technicians for all washing machine brands.
          </p>

        </div>

        <div className="why-card">

          <div className="icon-box">
            ⚡
          </div>

          <h2>Same Day Service</h2>

          <p>
            Fast response and quick doorstep service anywhere in Chennai.
          </p>

        </div>

        <div className="why-card">

          <div className="icon-box">
            🛡️
          </div>

          <h2>Genuine Spare Parts</h2>

          <p>
            High quality original spare parts with warranty support.
          </p>

        </div>

        <div className="why-card">

          <div className="icon-box">
            💰
          </div>

          <h2>Affordable Pricing</h2>

          <p>
            Transparent pricing without hidden charges for every service.
          </p>

        </div>

      </div>

    </section>


<section className="service-process-section">

  {/* Heading */}

  <div className="process-heading">

    <span>How It Works</span>

    <h1>
      Easy Washing Machine <br />
      Service Process
    </h1>

    <p>
      Quick and simple process to book your multi brand washing machine
      service anywhere in Chennai.
    </p>

  </div>

  {/* Process Cards */}

  <div className="process-container">

    {/* Card 1 */}

    <div className="process-card">

      <div className="process-number">
        01
      </div>

      <h2>Book Service</h2>

      <p>
        Call us or book your washing machine service online easily.
      </p>

    </div>

    {/* Card 2 */}

    <div className="process-card">

      <div className="process-number">
        02
      </div>

      <h2>Technician Visit</h2>

      <p>
        Our expert technician visits your home for inspection and repair.
      </p>

    </div>

    {/* Card 3 */}

    <div className="process-card">

      <div className="process-number">
        03
      </div>

      <h2>Service Complete</h2>

      <p>
        Quick repair with genuine spare parts and service warranty support.
      </p>

    </div>

  </div>

</section>


<section className="counter-section">

  {/* Counter Box 1 */}

  <div className="counter-box">

    <h1>15+</h1>

    <p>Years Experience</p>

  </div>

  {/* Counter Box 2 */}

  <div className="counter-box">

    <h1>12K+</h1>

    <p>Happy Customers</p>

  </div>

  {/* Counter Box 3 */}

  <div className="counter-box">

    <h1>8K+</h1>

    <p>Machines Repaired</p>

  </div>

  {/* Counter Box 4 */}

  <div className="counter-box">

    <h1>24/7</h1>

    <p>Customer Support</p>

  </div>

</section>


<section className="review-section">

  {/* Heading */}

  <div className="review-heading">

    <span>Customer Reviews</span>

    <h1>
      What Our Customers <br />
      Say About Our Service
    </h1>

  </div>

  {/* Review Container */}

  <div className="review-container">

    {/* Card 1 */}

    <div className="review-card">

      <FaQuoteRight className="quote-icon" />

      <div className="review-top">

        <FaUserCircle className="user-icon" />

        <div>
          <h2>Arun Kumar</h2>
          <span>Anna Nagar, Chennai</span>
        </div>

      </div>

      <p>
        Very professional washing machine service. Technician arrived
        on time and repaired my LG machine quickly.
      </p>

      <div className="stars">
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </div>

    </div>

    {/* Card 2 */}

    <div className="review-card">

      <FaQuoteRight className="quote-icon" />

      <div className="review-top">

        <FaUserCircle className="user-icon" />

        <div>
          <h2>Priya Sharma</h2>
          <span>Velachery, Chennai</span>
        </div>

      </div>

      <p>
        Affordable pricing and genuine spare parts. Excellent multi
        brand washing machine service center in Chennai.
      </p>

      <div className="stars">
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </div>

    </div>

    {/* Card 3 */}

    <div className="review-card">

      <FaQuoteRight className="quote-icon" />

      <div className="review-top">

        <FaUserCircle className="user-icon" />

        <div>
          <h2>Vignesh R</h2>
          <span>Tambaram, Chennai</span>
        </div>

      </div>

      <p>
        Fast doorstep service for IFB washing machine repair. Highly
        recommended service center.
      </p>

      <div className="stars">
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </div>

    </div>

  </div>

</section>

<section className="faq-section">

  {/* Heading */}

  <div className="faq-heading">

    <span>FAQ</span>

    <h1>
      Frequently Asked <br />
      Questions
    </h1>

    <p>
      Quick answers about our multi brand washing machine repair
      and maintenance services in Chennai.
    </p>

  </div>

  {/* FAQ Container */}

  <div className="faq-container">

    {/* FAQ 1 */}

    <div className="faq-card">

      <h2>
        Do you provide doorstep washing machine service?
      </h2>

      <p>
        Yes, we provide fast doorstep washing machine repair and
        maintenance service across Chennai.
      </p>

    </div>

    {/* FAQ 2 */}

    <div className="faq-card">

      <h2>
        Which washing machine brands do you service?
      </h2>

      <p>
        We service LG, Samsung, IFB, Bosch, Whirlpool, Haier,
        Panasonic and all major washing machine brands.
      </p>

    </div>

    {/* FAQ 3 */}

    <div className="faq-card">

      <h2>
        Do you use genuine spare parts?
      </h2>

      <p>
        Yes, we use high quality genuine spare parts with warranty
        support for better performance and durability.
      </p>

    </div>

    {/* FAQ 4 */}

    <div className="faq-card">

      <h2>
        How quickly can a technician visit?
      </h2>

      <p>
        Our technician usually visits on the same day based on
        your location and service availability.
      </p>

    </div>

  </div>

</section>









    </>
  );
}

export default Home;